import defaultApi from '../../api/defaultApi';

const BASE_URL = '/persona';

export const obtenerListadoPersonasPorTipo = async (tipoCodigo) => {
    const response = await defaultApi.get(`${BASE_URL}/tipo/${tipoCodigo}`);
    return response;
};
